import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { Layout } from "@/components/Layout";
import { Loader2 } from "lucide-react";
import Auth from "@/pages/Auth";
import AuthCallback from "@/pages/AuthCallback";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import Scan from "@/pages/Scan";
import ProgressPage from "@/pages/Progress";
import History from "@/pages/History";
import Profile from "@/pages/Profile";
import Coach from "@/pages/Coach";

function Splash() {
  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center gap-4" data-testid="splash">
      <div className="text-3xl font-display font-medium tracking-tight text-primary">calorify</div>
      <Loader2 className="w-5 h-5 animate-spin text-muted-foreground" />
    </div>
  );
}

function Gate({ children }) {
  const { session, profile, loading } = useAuth();
  if (loading) return <Splash />;
  if (!session) return <Navigate to="/auth" replace />;
  if (!profile?.onboarding_completed) return <Navigate to="/onboarding" replace />;
  return children;
}

function Routing() {
  const { session, profile, loading } = useAuth();
  return (
    <Routes>
      <Route
        path="/auth"
        element={loading ? <Splash /> : session ? <Navigate to="/" replace /> : <Auth />}
      />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route
        path="/onboarding"
        element={
          loading ? (
            <Splash />
          ) : !session ? (
            <Navigate to="/auth" replace />
          ) : profile?.onboarding_completed ? (
            <Navigate to="/" replace />
          ) : (
            <Onboarding />
          )
        }
      />
      <Route element={<Gate><Layout /></Gate>}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/progress" element={<ProgressPage />} />
        <Route path="/history" element={<History />} />
        <Route path="/profile" element={<Profile />} />
      </Route>
      <Route path="/scan" element={<Gate><Scan /></Gate>} />
      <Route path="/coach" element={<Gate><Coach /></Gate>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routing />
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
